import script from "./log.vue?vue&type=script&lang=ts&setup=true"
export * from "./log.vue?vue&type=script&lang=ts&setup=true"

import "./log.scss?vue&type=style&index=0&id=0df8173e&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df8173e"]])

export default __exports__